module.exports = __webpack_public_path__ + "img/banner-img-2.1fea8dd3.jpg";